module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0033.86e1e03e.jpg";